import Vue from 'vue'

import App from './App.vue'
import router from './core/router'
import store from './core/store'

// Validation
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// Assets
import './core/assets/css/font-awesome/css/font-awesome.min.css'
import './core/assets/css/animate.min.css'

// Plugin
import '@/core/plugins'

// Bootstrap
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './core/assets/css/sb-admin-2.css'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

// Layout
import Default from "@/core/views/template/Default.vue";
import NoFooter from "@/core/views/template/NoFooter.vue";

Vue.component('default-layout',Default)
Vue.component('no-footer-layout',NoFooter)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
